import React from 'react';
import camelcase from 'camelcase-es5';

import getSVGIconClassName from '../../utils/className/getSVGIconClassName';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import Box from '../Box/Box';
import { TIconProps } from './types';

// Map older color variants to use token colors
const colorMap = {
  success: 'signal-success-default',
  error: 'signal-error-default',
  action: 'text-link-hover',
  inverse: 'background-default',
  secondary: 'text-secondary',
  info: 'signal-info-default',
  warning: 'signal-warning-default',
  tertiary: 'text-secondary',
  link: 'signal-link-default',
};

/**
 * Icon component that interfaces with the svg sprites
 */
const Icon = ({ name, color, size, className: externalClassName = '', ...rest }: TIconProps) => {
  const svgIconClassName = getSVGIconClassName(name);
  const className = `${externalClassName} ${svgIconClassName}`.trim();
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [size, color && camelcase(colorMap[color] || color)],
  });

  return (
    <Box {...rest} {...conditionalProps} name="Icon" as="i" aria-hidden="true" className={className} data-sem="Icon" />
  );
};

export default React.memo(Icon);
